export const USERS = {
  login: "login",
  users: "add-user",
  // loginGoogle: "login/google",   // 👈 futuro: app con Google / Apple
};

export const MENU = {
  publico: "menu",
  admin: "admin/menu",
  secciones: "secciones",
  seccionById: "secciones/{seccionId}",
  productos: "productos",
  productoById: "productos/{productoId}",
};

export const PROMOS = {
  promos: "promos",
  promoById: "promos/{promoId}",
};

// export const PEDIDOS = {         // 👈 futuro: compras desde la app
//   pedidos: "pedidos",
// };
